export const FLAGS_COMPARE_FUNCTIONS = {
  BOOLEAN: (oldFlag, newFlag) => oldFlag.variation !== newFlag.variation,
};

export const FLAGS = {
  WEB_TO_NATIVE_CHECKOUT: {
    KEY: 'web-to-native-checkout',
    COMPARE_FN: FLAGS_COMPARE_FUNCTIONS.BOOLEAN,
  },
};

export const FLAGS_KEYS = Object.values(FLAGS).map(x => x.KEY);
